import { useLayoutEffect, useRef, type ReactNode } from "react";

/** Phone chrome must not be clamped by the Game tab's increasingly tall header. */
export function SurvivorStatusDock({ children }: { children: ReactNode }) {
  const space = useRef<HTMLDivElement>(null);
  const dock = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const element = dock.current;
    const reserve = space.current;
    if (element === null || reserve === null) return;
    const measure = () => {
      reserve.style.setProperty(
        "--survivor-dock-height",
        `${element.getBoundingClientRect().height}px`,
      );
    };
    measure();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, []);
  return (
    <div
      ref={space}
      className="sm-survivor-dock-space contents"
      data-testid="survivor-status-dock-space"
    >
      <div
        ref={dock}
        data-testid="survivor-status-dock"
        className="sm-survivor-status-dock sm-sticky-above-nav sticky bottom-0 z-10"
      >
        {children}
      </div>
    </div>
  );
}
